// interface Headers {
//     [K: string]: string;
//     Authorization: string;
//     'Content-Type': 'application/json';
// }

const getHeaders = (
    token: string,
    getGuid: () => string,
    getDevMode: () => boolean,
    sessionId?: string,
    isBeta?: () => boolean,
    customHeaders?: {
        isCustomHeadersEnabled?: boolean;
        brandName?: string;
        daznId?: string;
    },
) => {
    const headers: Record<string, string> = {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        'Content-Type': 'application/json',
    };

    if (sessionId) {
        headers['X-Session-Id'] = sessionId;
    }

    if (getDevMode() === true) {
        headers['X-Dazn-Marco'] = '';
        headers['X-Dazn-Device'] = getGuid();
    }

    if (isBeta?.()) headers['x-dazn-beta-locale'] = 'true';

    // Add custom common headers if enabled
    if (customHeaders?.isCustomHeadersEnabled) {
        if (customHeaders.brandName) {
            headers['X-BRAND'] = customHeaders.brandName;
        }
        if (customHeaders.daznId && token) {
            headers['X-DAZNID'] = customHeaders.daznId;
        }
    }

    return headers;
};

export { getHeaders };
